/* eslint-disable import/no-duplicates */
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { useQuery } from '@apollo/client';
import { usePathname, useSearchParams } from 'next/navigation';
import { Modal } from '@madeeasy/universal-login';
import PageHeader from '../../components/shared/PageHeader';
import LayoutComponent from '../../components/home/layouts/LayoutComponent';
import GET_JSON_VARIABLE from '../../gql/queries/get-json-variable.gql';
import { getOrganizationPropertiesByHost, isWebView } from '../../utils/helpers';
import GET_SLOT_BOOKING from '../../gql/queries/get-slot-bookings.gql';
import SlotBookingForm from '../../components/slot-booking/SlotBookingForm';
import { useUser } from '../../contexts/ssr-user-context';
import { useMiscellaneousData } from '../../contexts/ssr-miscellaneous-context';

function SlotBooking() {
  const { miscellaneousData } = useMiscellaneousData();
  const currentOrg = getOrganizationPropertiesByHost(miscellaneousData?.hostname);

  const [showLogin, setShowLogin] = useState(false);
  const { user } = useUser();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const toggleModal = () => {
    setShowLogin(!showLogin);
  };
  function domainBaseUrl() {
    return window.location.origin;
  }
  const handleRedirect = () => {
    const encodeUrl = encodeURIComponent(`${domainBaseUrl()}/prep/slot-booking`);
    const params = new URLSearchParams(searchParams.toString());
    params.set('redirectTo', encodeUrl);
    const newUrl = `${pathname}?${params.toString()}`;
    window.history.replaceState(null, '', newUrl);
  };
  useEffect(() => {
    if (!user?.id) {
      handleRedirect();
      setShowLogin(true);
    }
  }, [user]);
  const { data, loading, error } = useQuery(GET_JSON_VARIABLE, {
    variables: {
      name: 'slot_bookings',
      language: 'en',
    },
  });
  const { data: slotBookingResponse, refetch: slotBookingRefetch } = useQuery(GET_SLOT_BOOKING, {
    filter: {
      scope: 'counselling',
    },
  });
  const slotBookings = slotBookingResponse?.getSlotBookings || null;
  if (loading) {
    return (
      <LayoutComponent pageTitle="Slot Booking" headerType="2" paddingClass="p-0" pageName="slotBooking" isShowFooterTabs={false} headerMobileNotShow>
        <div className="flex justify-center items-center h-96">
          <span className="text-lg font-semibold">Loading...</span>
        </div>
        {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}
      </LayoutComponent>
    );
  }
  if (error) {
    return (
      <LayoutComponent pageTitle="Slot Booking" headerType="2" paddingClass="p-0" pageName="slotBooking" isShowFooterTabs={false} headerMobileNotShow>
        <div className="flex justify-center items-center h-96">
          <span className="text-lg font-semibold text-red-500">Error loading slot booking data.</span>
        </div>
        {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}
      </LayoutComponent>
    );
  }
  const slotBookingData = data?.getJsonVariable?.value || {};
  return (
    <LayoutComponent
      pageTitle="Slot Booking"
      headerType="2"
      paddingClass="p-0"
      pageName="slotBooking"
      headerMobileNotShow
      isShowFooterTabs={false}
    >
      <div className="w-full h-full rounded-md  bg-white px-4 sm:px-6 md:px-0">
        <div className="ml-0 md:ml-10 mt-8">
          <PageHeader
            pageHeading={slotBookingData?.title}
            showHeading={!isWebView()}
            marginClass={`${isWebView() ? 'mb-0' : 'lg:mb-0'}`}
            breadCrumb={(
              <span className="text-[#0267B1]">
                <Link href="/home">Home</Link>
                {' '}
                /
                {' '}
                <span className="text-[#0267B1]">Counselling</span>
              </span>
            )}
          />
        </div>
        <div className="flex flex-col justify-center items-center w-full md:w-[60%] mx-auto">
          <p className="text-[16px] md:text-xl font-medium max-w-md">
            {slotBookingData?.description}
          </p>
          <SlotBookingForm
            slotBookingData={slotBookingData}
            slotBookings={slotBookings}
            domainName={currentOrg}
            refetch={slotBookingRefetch}
          />
        </div>
      </div>
      {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}
    </LayoutComponent>
  );
}

export default SlotBooking;
